import Rails from "@rails/ujs";

import currentLocale from "shared/currentLocale";

export default ({ resourceId, startsOn, endsOn, quantity, success, error }) => {
  const params = `resource_id=${resourceId}&starts_on=${startsOn}&ends_on=${endsOn}&quantity=${quantity}`;

  Rails.ajax({
    type: "GET",
    dataType: "json",
    url: `/${currentLocale()}/frontoffice/api/resource_skus/available?${params}`,
    success,
    error,
  });
};
